import React from "react";
import { Grid, Typography } from "@mui/material";
import { VehicleDateField, VehicleNumberField, VehicleCheckboxField } from "../VehicleFormFields";

const SafetyTab: React.FC = () => {
  return (
    <>
      <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
        Track important safety-related dates and financial information.
      </Typography>
      <Grid container spacing={2}>
        <Grid item xs={12} sm={6}>
          <VehicleDateField 
            name="dotInspectionExpiration" 
            label="DOT Inspection Expiration" 
            tooltip="When the current DOT inspection expires"
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <VehicleDateField 
            name="platesExpirationDate" 
            label="Plates Expiration Date" 
            tooltip="When the license plates expire"
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <VehicleDateField 
            name="insuranceExpirationDate" 
            label="Insurance Expiration Date" 
            tooltip="When the current insurance policy expires"
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <VehicleNumberField 
            name="insuranceValue" 
            label="Insurance Value ($)" 
            step={0.01} 
            tooltip="Current insured value of the vehicle"
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <VehicleNumberField 
            name="escrowStartingBalance" 
            label="Escrow Starting Balance ($)" 
            step={0.01} 
            tooltip="Initial balance in escrow account"
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <VehicleNumberField 
            name="escrowAccountBalance" 
            label="Escrow Account Balance ($)" 
            step={0.01} 
            tooltip="Current balance in escrow account"
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <VehicleCheckboxField 
            name="hasCustomWarning" 
            label="Custom Warning" 
            tooltip="Enable custom warning notifications for this vehicle"
          />
        </Grid>
      </Grid>
    </>
  );
};

export default SafetyTab;
